import { Switch } from '@headlessui/react';
import { Spin } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { loyaltyApi } from '../../api/loyalty';
import { SQLoyaltyProgram, TTLoyalty } from '../../interfaces/loyalty';
import { TTUserProfile } from '../../interfaces/user';
import { RootState } from '../../rootReducer';
import { LoadingIcon } from '../components/Spinner';

type Props = {
  merchant_ids: number[];
  onCheck: (register: boolean) => void;
};

export function SQLoyaltyCheck({ merchant_ids, onCheck }: Props) {
  const [loyaltyPrograms, setLoyaltyPrograms] = useState<SQLoyaltyProgram[]>(
    [],
  );
  const guest = useSelector<RootState, TTUserProfile | null>(
    state => state.auth.userProfile,
  );
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [guestPrograms, setGuestPrograms] = useState<TTLoyalty[]>([]);

  const [allRegistered, setAllRegistered] = useState(false);

  const fetchLoyaltyPrograms = async () => {
    try {
      setLoading(true);
      const response = await loyaltyApi.getMerchantProgram(merchant_ids);
      setLoyaltyPrograms(response.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useMemo(() => {
    if (
      loyaltyPrograms.length !== 0 &&
      guestPrograms.length >= loyaltyPrograms.length
    ) {
      setAllRegistered(true);
    }
  }, [guestPrograms, loyaltyPrograms]);

  const fetchGuestPrograms = async () => {
    try {
      setLoading(true);
      const response = await loyaltyApi.getCustomerLoyaltyAccount(
        guest.phone_number,
        null,
        merchant_ids,
      );
      setGuestPrograms(response.data);
      setLoading(false);
    } catch (e) {
      console.log(e.response?.data);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLoyaltyPrograms();
  }, []);

  useEffect(() => {
    if (guest) {
      fetchGuestPrograms();
    }
  }, [guest?.id]);

  return (
    <>
      {allRegistered && !loading ? (
        <div className="flex rounded-md px-4 py-2 bg-primary/10 text-on-surface text-md">
          Earning loyalty points at these merchants!
        </div>
      ) : loyaltyPrograms.length === 0 ? (
        <></>
      ) : (
        <>
          <label className="block uppercase tracking-wide text-on-surface text-sm font-bold mb-4">
            Loyalty
          </label>
          <div className="flex rounded-md px-4 py-2 bg-primary/10">
            <Spin spinning={loading} indicator={LoadingIcon}>
              <Switch.Group>
                <div className="flex items-center">
                  <Switch.Label className="mr-4 text-md text-on-surface">
                    Sign up for Loyalty & Earn Rewards
                  </Switch.Label>
                  <Switch
                    checked={checked}
                    onChange={() => {
                      setChecked(!checked);
                      onCheck(!checked);
                    }}
                    className={`${
                      checked ? 'bg-primary' : 'bg-surface-variant'
                    } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
                  >
                    <span
                      className={`${
                        checked ? 'translate-x-6' : 'translate-x-1'
                      } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                    />
                  </Switch>
                </div>
              </Switch.Group>
            </Spin>
          </div>
        </>
      )}
    </>
  );
}
